import { inject } from '@angular/core'
import { CanActivateChildFn, Router } from '@angular/router'
import { AppStore } from '../app.store'
import { ToastrService } from 'ngx-toastr'
import { AuthService } from '@auth0/auth0-angular'

export const trialGuardFn: CanActivateChildFn = (route, state) => {
    const appStore = inject(AppStore)
    const authService = inject(AuthService)
    const router = inject(Router)
    const toastr = inject(ToastrService)

    const me = appStore.me()

    const paymentUrl = '/admin/subscription/payment-details'

    if (state.url !== paymentUrl && !me?.subscription.onTrial && me?.subscription.paymentDetailsRequired) {
        if (me?.isAdmin) {
            // User has an active subscription but has not provided payment details
            toastr.error('Please provide payment details', 'Payment Details Required', { disableTimeOut: true })
            router.navigateByUrl('/admin/subscription/payment-details')
            return true
        }

        toastr.error('Your trial has ended, an administrator must login and supply payment details.', 'Trial Ended', {
            timeOut: 10_000,
        })
        authService.logout()
    }

    return true
}
